// extracted by mini-css-extract-plugin
export default {"infoBlock":"TextData_infoBlock__ft-cM"};